import * as Actions from '../constant/ActionTypes';

const rbacDataReducer = (rbacData = {}, action) => {
    switch(action.type) {
        case Actions.RBAC_DATA:
            return action.payload;
        default :
            return rbacData;
    }
}
export default rbacDataReducer;